<app-header></app-header>

<div class="container-fluid bg-primary py-5 bg-header mrb-90">
    <div class="row py-5">
        <div class="col-12 pt-lg-5 mt-lg-5 text-center">
            <h1 class="display-4 text-white">Free Quote</h1>
            <a routerLink="/" class="h5 text-white">Home</a>
            <i class="far fa-circle text-white px-2"></i>
            <a routerLink="/quote" class="h5 text-white">Free Quote</a>
        </div>
    </div>
</div>

<!-- Quote Start -->
<div class="container-fluid py-5">
    <div class="container py-5">
        <div class="row g-5">
            <!-- Left Content -->
            <div class="col-lg-7">
                <div class="section-title position-relative pb-3 mb-5">
                    <h5 class="fw-bold text-primary text-uppercase">Request A Quote</h5>
                    <h1 class="mb-0">Let's Build Something Creative Together</h1>
                </div>
                <div class="row gx-3">
                    <div class="col-sm-6">
                        <h5 class="mb-4"><i class="fa fa-reply text-primary me-3"></i>We usually respond within 1 hour
                        </h5>
                    </div>
                    <div class="col-sm-6">
                        <h5 class="mb-4"><i class="fa fa-phone-alt text-primary me-3"></i>Instant project consultation
                        </h5>
                    </div>
                </div>
                <p class="mb-4">Got a project in mind? Whether it's a new brand identity, website design, or digital
                    campaign we're ready to turn your ideas into reality. Let's discuss how we can help bring your
                    vision to life.</p>
                <div class="d-flex align-items-center mt-2 wow zoomIn" data-wow-delay="0.6s">
                    <div class="bg-primary d-flex align-items-center justify-content-center border-radius"
                        style="width: 60px; height: 60px;">
                        <i class="fa fa-phone-alt text-white"></i>
                    </div>
                    <div class="ps-4">
                        <h5 class="mb-2">Call us to discuss your idea</h5>
                        <h4 class="text-primary mb-0">+012 345 6789</h4>
                    </div>
                </div>
            </div>

            <!-- Quote Form -->
            <div class="col-lg-5">
                <div class="bg-primary border-radius h-100 d-flex align-items-center p-5">
                    <form (submit)="sendEmail($event)" #contactForm="ngForm">
                        <div class="row g-3">
                            <div class="col-xl-12">
                                <div class="form-group">
                                    <label class="visually-hidden" for="user_name">Name</label>
                                    <input class="border-radius" type="text" minlength="2" maxlength="15" [class.is-invalid]="userName.invalid && userName.touched"
                                        name="user_name" id="name" placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                                    <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mrb-10">
                                        Name is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <input type="email" minlength="2" maxlength="35" [class.is-invalid]="userEmail.invalid && userEmail.touched"
                                        name="user_email" class="md-input border-radius" id="email" placeholder="Email *" [(ngModel)]="formData.user_email"
                                        #userEmail="ngModel" required email>
                                    <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mrb-10">
                                        A valid email is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <select class="form-select bg-light border-radius form-control">
                                    <option selected>Select a Service</option>
                                    <option value="branding">Branding & Logo Design</option>
                                    <option value="web">Website Design</option>
                                    <option value="uiux">UI/UX Design</option>
                                    <option value="marketing">Digital Marketing</option>
                                </select>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="visually-hidden" for="message">Project Details</label>
                                    <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched" class="md-textarea border-radius"
                                        id="message" rows="7" placeholder="Project Details" [(ngModel)]="formData.message" #userMessage="ngModel"
                                        required></textarea>
                                    <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                                        Project details are required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <button class="btn btn-dark w-100 fw-medium py-3 border-radius" type="submit" name="submit" [disabled]="contactForm.invalid" value="Get Quote">Get Quote</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Quote End -->

<!-- Brands Start -->
<div class="container-fluid">
    <div class="container py-5 mb-5">
        <div class="bg-white">
            <owl-carousel-o [options]="brandsCarousel" class="owl-btn-center-lr vendor-carousel">
                <ng-template carouselSlide *ngFor="let brand of brandStore">
                    <div class="client-box">
                        <a href="#."><img src="assets/images/{{brand.img}}" alt="brand-img"></a>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>
<!-- Brands End -->